import * as React from 'react';
import { observer } from 'mobx-react';
import { Option } from '@payscale/design';
import { BaseEmployeeLevel } from 'nomst/Stores/Configuration/baseEmployeeLevel';

interface IAccessGroupOptionProps {
    readonly: boolean;
    hrReviewer: BaseEmployeeLevel;
}

@observer
export default class AccessGroupOption extends React.Component<IAccessGroupOptionProps> {
    constructor(props: IAccessGroupOptionProps) {
        super(props);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    render(): React.ReactNode {
        const { hrReviewer, readonly } = this.props;
        return (
            <div className="access-group-option">
                {readonly ? <span>{hrReviewer.levelName}</span>: 
                    <Option
                        id={hrReviewer.accessGroupId}
                        text={hrReviewer.levelName}
                        checked={hrReviewer.isSelected}
                        onChange={this.handleOnChange}
                        className="pxl-option--secondary"
                    />}
            </div>
        );
    }

    private handleOnChange(): void {
        const { hrReviewer } =  this.props;
        hrReviewer.toggleSelection();
    }
}
